(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lohan-frete-calc"] && !Shopify.designMode) return;
  try {
    (function () {
    function money(v) {
      try { return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); } catch (e) { return 'R$ ' + v; }
    }

    // Frete grátis por região (mesma régua da faixa do carrinho): ES R$ 350, Sudeste R$ 500, demais R$ 1.000.
    function limiteGratis(uf) {
      if (uf === 'ES') return 350;
      if (uf === 'SP' || uf === 'RJ' || uf === 'MG') return 500;
      return 1000;
    }

    // Total do carrinho em reais já sem os decants grátis (a cada 5 decants, o de menor valor sai grátis).
    function totalComPromo(cart) {
      var total = cart.total_price || 0;
      var desc = 0;
      if (window.__lohanKitCalcula) {
        desc = window.__lohanKitCalcula(cart).desc;
      } else {
        var precos = [];
        (cart.items || []).forEach(function (it) {
          if (/decant/i.test(it.variant_title || '')) {
            for (var q = 0; q < it.quantity; q++) precos.push(it.final_price);
          }
        });
        precos.sort(function (a, b) { return a - b; });
        for (var i = 0; i < Math.floor(precos.length / 5); i++) desc += precos[i];
      }
      if (desc > 0 && desc < total) total -= desc;
      return total / 100;
    }

    // Pacote a partir dos itens do carrinho (kg / cm), mesmas medidas da calculadora do produto.
    function pacote(cart) {
      var peso = 0, altura = 2, largura = 11, comprimento = 16;
      (cart.items || []).forEach(function (it) {
        var t = ((it.variant_title || '') + ' ' + (it.title || '')).toLowerCase();
        var p, h, w, l;
        if (t.indexOf('5 ml') !== -1) { p = 0.015; h = 6; w = 2; l = 2; }
        else if (t.indexOf('10 ml') !== -1) { p = 0.05; h = 7.5; w = 2.5; l = 2.5; }
        else { p = it.grams > 0 ? it.grams / 1000 : 0.35; h = 12; w = 8; l = 8; }
        peso += p * it.quantity;
        altura = Math.max(altura, h);
        largura = Math.max(largura, w);
        comprimento = Math.max(comprimento, Math.min(100, l * it.quantity));
      });
      return { weight: Math.max(peso, 0.01), height: altura, width: largura, length: comprimento };
    }

    function init(root) {
      if (!root || root.__fcalcWired) return;
      root.__fcalcWired = true;
      var form = root.querySelector('[data-fcalc-form]');
      var input = root.querySelector('[data-fcalc-cep]');
      var btn = root.querySelector('[data-fcalc-go]');
      var out = root.querySelector('[data-fcalc-out]');
      var worker = root.getAttribute('data-worker-url');
      if (!form || !input || !out || !worker) return;

      // Máscara leve 00000-000 + CEP lembrado
      try { var saved = localStorage.getItem('lohan_cep'); if (saved) input.value = saved; } catch (e) {}
      input.addEventListener('input', function () {
        var d = input.value.replace(/\D/g, '').slice(0, 8);
        input.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
      });

      function show(html) { out.hidden = false; out.innerHTML = html; }
      function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var cep = (input.value || '').replace(/\D/g, '');
        if (cep.length !== 8) { show('<p class="lohan-fcalc__msg">Digite um CEP válido (8 dígitos).</p>'); input.focus(); return; }
        try { localStorage.setItem('lohan_cep', input.value); } catch (e2) {}
        btn.disabled = true; var label = btn.textContent; btn.textContent = 'Calculando…';
        show('<p class="lohan-fcalc__msg">Buscando as melhores opções…</p>');

        Promise.all([
          fetch('https://viacep.com.br/ws/' + cep + '/json/').then(function (r) { return r.json(); }).catch(function () { return {}; }),
          fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        ])
          .then(function (res) {
            var vc = res[0] || {};
            if (vc.erro) throw new Error('cep');
            var cart = res[1] || {};
            if (!cart.item_count) throw new Error('vazio');
            var pkg = pacote(cart);
            return fetch(worker, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ cep: cep, weight: pkg.weight, height: pkg.height, width: pkg.width, length: pkg.length })
            })
              .then(function (r) { return r.json(); })
              .then(function (data) { return { data: data || {}, cart: cart, uf: vc.uf || '', city: vc.localidade || '' }; });
          })
          .then(function (ctx) {
            var rates = (ctx.data.results || []).map(function (r) {
              return { name: r.name || 'Frete', price: Number(r.price), prazo: r.delivery_time || '' };
            }).filter(function (r) { return !isNaN(r.price); });
            if (!rates.length) { show('<p class="lohan-fcalc__msg">Não encontramos frete para esse CEP. Fale com a gente no WhatsApp que resolvemos.</p>'); return; }

            var cartTotal = totalComPromo(ctx.cart);
            if (ctx.uf && cartTotal >= limiteGratis(ctx.uf)) {
              var pac = rates.filter(function (r) { return /pac/i.test(r.name); })[0];
              rates.push({ name: 'Frete grátis (PAC)', price: 0, prazo: pac ? pac.prazo : '' });
            }
            rates.sort(function (a, b) { return a.price - b.price; });

            var best = rates[0].price;
            var where = ctx.city ? (ctx.city + (ctx.uf ? ' - ' + ctx.uf : '')) : '';
            var items = rates.map(function (r, i) {
              var priceHtml = r.price === 0
                ? '<span class="lohan-fcalc__opt-price lohan-fcalc__opt-price--free">Grátis'
                : '<span class="lohan-fcalc__opt-price">' + money(r.price);
              if (r.prazo) priceHtml += '<span class="lohan-fcalc__opt-prazo">' + esc(r.prazo) + '</span>';
              priceHtml += '</span>';
              return '<li class="lohan-fcalc__opt' + (i === 0 ? ' lohan-fcalc__opt--best' : '') + '">' +
                '<span class="lohan-fcalc__opt-name">' + esc(r.name) + '</span>' + priceHtml + '</li>';
            }).join('');
            show((where ? '<p class="lohan-fcalc__msg">Frete para ' + esc(where) + ':</p>' : '') +
              '<ul class="lohan-fcalc__list">' + items + '</ul>' +
              '<div class="lohan-fcalc__total"><span>Total com frete (' + (best === 0 ? 'grátis' : 'a partir de') + ')</span>' +
              '<span class="lohan-fcalc__total-val">' + money(cartTotal + best) + '</span></div>');
          })
          .catch(function (err) {
            if (err && err.message === 'cep') { show('<p class="lohan-fcalc__msg">CEP não encontrado. Confira o número.</p>'); }
            else if (err && err.message === 'vazio') { show('<p class="lohan-fcalc__msg">Seu carrinho está vazio.</p>'); }
            else { show('<p class="lohan-fcalc__msg">Não foi possível calcular agora. Tente de novo em instantes.</p>'); }
          })
          .then(function () { btn.disabled = false; btn.textContent = label; });
      });
    }
    function boot() { document.querySelectorAll('[data-lohan-fcalc]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
    // Recarrega em drawers que injetam o carrinho dinamicamente
    document.addEventListener('cart:refresh', boot);
    new MutationObserver(function () { boot(); }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lohan-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__lohanQA) return;
    window.__lohanQA = true;
    function aviso(nome) {
      var t = document.querySelector('.lohan-qa-toast');
      if (!t) {
        t = document.createElement('div');
        t.className = 'lohan-qa-toast';
        t.setAttribute('role', 'status');
        document.body.appendChild(t);
      }
      t.innerHTML = '<span>✓ <strong>' + nome + '</strong> adicionado ao carrinho</span><a href="/cart">Finalizar compra</a>';
      t.classList.add('is-on');
      clearTimeout(t.__timer);
      t.__timer = setTimeout(function () { t.classList.remove('is-on'); }, 4000);
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lqa]');
      if (!b || b.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var box = b.closest('.lohan-qa');
      var nome = (box && box.getAttribute('data-produto')) || 'Produto';
      var original = b.innerHTML;
      b.disabled = true;
      b.classList.add('is-load');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-lqa')), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js').then(function (x) { return x.json(); }); })
        .then(function (cart) {
          b.classList.remove('is-load');
          b.classList.add('is-ok');
          b.innerHTML = '<span class="lohan-qa__nome">✓ Adicionado</span>';
          // Atualiza o número do carrinho no cabeçalho
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'lohan-qa', data: { itemCount: cart.item_count, source: 'lohan-qa' } }
          }));
          document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          // Decant: a notificação da promoção (4+1) já aparece; frasco: aviso simples
          if (!b.hasAttribute('data-decant')) aviso(nome);
        })
        .catch(function () {
          b.classList.remove('is-load');
          b.innerHTML = '<span class="lohan-qa__nome">Indisponível</span>';
        })
        .then(function () {
          setTimeout(function () { b.disabled = false; b.classList.remove('is-ok'); b.innerHTML = original; }, 1800);
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
